// extracted by mini-css-extract-plugin
export var mobNav = "mobnavbar-module--mobNav--2pbzH";
export var logo = "mobnavbar-module--logo--SmwCD";
export var burgerIcon = "mobnavbar-module--burgerIcon--2RLu2";
export var navLinkContainer = "mobnavbar-module--navLinkContainer--39ESU";
export var links = "mobnavbar-module--links--105ys";
export var links2 = "mobnavbar-module--links2--12kZ9";